import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API || 'http://localhost:5000/api';

export default function AdminDashboard() {
  const [students, setStudents] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', password: '', roll_number: '', course: '' });
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchStudents();
  }, []);

  async function fetchStudents() {
    try {
      const res = await axios.get(`${API}/students`, { headers: { Authorization: `Bearer ${token}` } });
      setStudents(res.data);
    } catch (err) {
      console.error(err);
    }
  }

  async function createStudent(e) {
    e.preventDefault();
    try {
      await axios.post(`${API}/students`, form, { headers: { Authorization: `Bearer ${token}` } });
      setForm({ name: '', email: '', password: '', roll_number: '', course: '' });
      fetchStudents();
    } catch (err) {
      console.error(err.response || err);
    }
  }

  async function deleteStudent(id) {
    if (!window.confirm('Delete student?')) return;
    await axios.delete(`${API}/students/${id}`, { headers: { Authorization: `Bearer ${token}` } });
    fetchStudents();
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Admin Dashboard</h2>
      <h3>Create Student</h3>
      <form onSubmit={createStudent} style={{ marginBottom: 12 }}>
        <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <input placeholder="Password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        <input placeholder="Roll" value={form.roll_number} onChange={(e) => setForm({ ...form, roll_number: e.target.value })} />
        <input placeholder="Course" value={form.course} onChange={(e) => setForm({ ...form, course: e.target.value })} />
        <button type="submit">Create</button>
      </form>

      <h3>Students</h3>
      <table border="1" cellPadding="6">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Roll</th>
            <th>Course</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.map((s) => (
            <tr key={s.id}>
              <td>{s.id}</td>
              <td>{s.name}</td>
              <td>{s.email}</td>
              <td>{s.roll_number}</td>
              <td>{s.course}</td>
              <td>
                <button onClick={() => deleteStudent(s.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
